
export const getStatusText = (status) => {
    const statusMap = {
        '0': '未处理',
        '1': '处理中',
        '2': '已处理',
        '3': '已忽略',
        '4': '已关闭',
        '5': '已升级',
    };
    return statusMap[status] || '未知';
};

export const getAlarmType = (type) => {
    const typeMap = {
        '1': '超速',
        '2': '越界',
        '3': '闯入禁行区',
        '4': '超区域行驶',
        '5': '急减速',
        '6': '异常停留',
        '7': '车辆故障',
    };
    return typeMap[type] || '未知';
};